// Date helpers that use the local timezone (not UTC)

function pad2(n) {
  return String(n).padStart(2, "0");
}

// Format a Date object as YYYY-MM-DD in local time
export function formatYMDLocal(date = new Date()) {
  const y = date.getFullYear();
  const m = pad2(date.getMonth() + 1);
  const d = pad2(date.getDate());
  return `${y}-${m}-${d}`;
}

// Convenience: today as YYYY-MM-DD in local time
export function todayYMDLocal() {
  return formatYMDLocal(new Date());
}

// Add or subtract days from a date (local) and return YYYY-MM-DD
export function addDaysYMDLocal(date, deltaDays) {
  const d = new Date(date);
  d.setDate(d.getDate() + deltaDays);
  return formatYMDLocal(d);
}

